import React, { createContext, useContext, useState } from 'react';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react-dom';

const ReferenceContext = createContext(null);
export function Manager({ children }) {
  const [reference, setReference] = useState(null);
  return <ReferenceContext.Provider value={{ reference, setReference }}>{children}</ReferenceContext.Provider>;
}
export function Reference({ children }) {
  const { setReference } = useContext(ReferenceContext);
  return children({ ref: setReference });
}
export function Popper({ children, placement = 'top', strategy = 'fixed', modifiers = [] }) {
  const { reference } = useContext(ReferenceContext);
  const gap = modifiers.find(item => item.name === 'offset')?.options?.offset?.[1] || 0;
  const floating = useFloating({ elements: { reference }, placement, strategy, middleware: [offset(gap), flip(), shift({ padding: 8 })], whileElementsMounted: autoUpdate });
  return children({ ref: floating.refs.setFloating, style: floating.floatingStyles, placement: floating.placement, forceUpdate: floating.update });
}
